import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-no-wrap" }

import { ref, watch } from 'vue'
import axios from 'axios'
import { useUserStore } from '@/stores/user'
import { API_BASE_URL } from '@/services/api'

interface Payment {
  id: number
  place: string
  amount: number
  datetime: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Payments',
  setup(__props) {

const userStore = useUserStore()
const userdata = ref<Payment[]>([])

const now = new Date()
const pad = (n: number) => String(n).padStart(2, '0')
const selectedMonth = ref(`${now.getFullYear()}-${pad(now.getMonth() + 1)}`)
const maxMonth = `${now.getFullYear()}-${pad(now.getMonth() + 1)}`

const formatDate = (datetime: string) => {
  if (!datetime) return ''
  const d = new Date(datetime)
  return d.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

const getPhoneNumber = () => {
  return userStore.state.context.user?.phoneNumber?.substring(4) || ''
}

const fetchPayments = async () => {
  if (userStore.state.value === 'authenticated') {
    const phoneNumber = getPhoneNumber()
    if (!phoneNumber) return

    try {
      const response = await axios.get(
        `${API_BASE_URL}/getuserinfo2paymants?number=${phoneNumber}&month=${selectedMonth.value}`
      )
      userdata.value = response.data
    } catch (error) {
      console.error('Error fetching payments:', error)
    }
  }
}

watch(
  () => userStore.state.value,
  async (state) => {
    if (state === 'authenticated') {
      await fetchPayments()
    }
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "payments-container" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { dense: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: selectedMonth.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedMonth).value = $event)),
                    type: "month",
                    max: maxMonth,
                    label: "Период",
                    density: "compact",
                    variant: "outlined",
                    "hide-details": "",
                    class: "mx-4 mt-3",
                    style: {"max-width":"220px"},
                    onChange: fetchPayments
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_v_table, { density: "compact" }, {
                    default: _withCtx(() => [
                      _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, "Терминал"),
                          _createElementVNode("th", null, "Сумма"),
                          _createElementVNode("th", null, "Дата")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userdata.value, (item) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: item.id
                          }, [
                            _createElementVNode("td", null, _toDisplayString(item.place), 1),
                            _createElementVNode("td", null, _toDisplayString((item.amount / 100).toFixed(2)) + " €", 1),
                            _createElementVNode("td", _hoisted_1, _toDisplayString(formatDate(item.datetime)), 1)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }),
                  (userdata.value.length === 0)
                    ? (_openBlock(), _createBlock(_component_v_card_text, {
                        key: 0,
                        class: "text-center text-medium-emphasis"
                      }, {
                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                          _createTextVNode(" Нет платежей за выбранный период ")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})